"use client";

import { useEffect } from "react";
import { trackMetaEvent } from "../lib/metaTracking";

const MetaCourseView = ({ courseSlug, category }) => {
  useEffect(() => {
    if (!courseSlug) return;

    trackMetaEvent({
      eventName: "ViewContent",
      customData: {
        content_name: courseSlug,
        content_category: category || "course",
        content_type: "product",
        content_ids: [courseSlug],
      },
    });
  }, [courseSlug, category]);

  return null;
};

export default MetaCourseView;
